import styled from 'styled-components';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

import { Section } from '@keaze/web/components/section';

export const SearchHero = styled(Box)`
  ${({ theme: { breakpoints, sizes } }) => `   
    margin-top: -${sizes.headerHeight.default};
    position: relative;
    height: 75px;
    display: none;

    ${breakpoints.down('sm')} {
      margin-top: -${sizes.headerHeight.sm};
      height: 215px;
    }    

    ${breakpoints.up('md')} {
      display: block;
    }    

    &:before {
      content: "";      
      background-size: cover;      
      background-repeat: no-repeat;
      background-color: white;
      position: absolute;
      top: 0;
      bottom: 0;
      width: 100vw;
     
      left: 50%;
      margin-left: -50vw;

      // ${breakpoints.up('sm')} {
      //   background-image: url("/images/search-hero-desktop.jpg");
      //   bottom: -80%;
      //   background-position: 0% 50%;
      // }

      // ${breakpoints.down('xs')} {
      //   background-image: url("/images/search-hero-mobile.jpg");
      //   background-position: 50% 30%;
      // }
    }
  `}
`;

export const SearchSection = styled(Section)`
  ${({ theme: { breakpoints } }) => `
    ${breakpoints.up('md')} {
     
      min-height: calc(100vh - 540px);
    }
  `}
`;

export const CardWrapper = styled(Box)`
${({ theme: { breakpoints } }) => `
${breakpoints.up('md')} {   padding: 30px 0;}
  position: relative;
  padding: 0;
  `}
`;

export const PropertiesTitle = styled(Typography)`
  ${({ theme: { breakpoints } }) => `
    margin-bottom: 15px;
    width: 40%

    ${breakpoints.up('md')} {
      margin-bottom: 0;
    }
  `}
`;

export const PropertiesFound = styled(Typography)`
  display: block;
  margin-bottom: -5px;

  color: #464646;
`;

export const PropertiesGrid = styled(Grid)`
  ${({ theme: { colors, breakpoints } }) => `
    margin-top: 20px;
display: flex;
flex-direction: row;
flex-wrap: nowrap;
max-width: auto;

h1 {font-size: 21px;}

    ${breakpoints.up('md')} {
      h1 {font-size: 1.875rem;}
   
    }
  `}
`;

export const PersonalizedSearchWrapper = styled(Grid)`
  ${({ theme: { breakpoints } }) => `
    flex-wrap: wrap;

    & > div:first-child {
      margin-bottom: 2px;
      flex: 1 0 50%;
      display: none;
     
    }

    & > div:last-child {
      flex: 1 1 auto;
  
    }

    ${breakpoints.up('sm')} {
      flex-wrap: nowrap;

      & > div:first-child {
        margin: 0 !important;
        flex: 1 0 calc(50% - 1px);
     
      }
    }

    ${breakpoints.up('md')} {
      & > div:last-child,
      & > div:first-child {
        width: auto;
        flex: unset;
      }
    }
  `}
`;

export const ItemProperties = styled(Grid)`
  ${({ theme: { breakpoints } }) => `
    // display: none;

    ${breakpoints.up('md')} {
      display: block;
    }
  `}
`;
